import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    accordianState: [],
    accordianTouched: [{
        // accordianIndex: 0,
        questionContent: [
            //     {
            //     questionIndex: 1,
            //     attachedQuestions: {
            //         content_Id: '',
            //         contentId: ''
            //     }
            // }
        ]
    }],
    accordianTest: [{
        testContent: []
    }],
    accordianCreateTouched: {},
    isComingFromQuestionComponent: false,
    isComingFromTest: false,
    isTabOpened: false,
    progressBarForQuestion: {
        percentage: 0,
        count: 0,
        totalCount: 0,
    },
    progressBarForTest: {
        percentage: 0,
        count: 0,
        totalCount: 0,
    },
    isBothTabOpen: false,
    overAllStatus: false,
    contentRequestItemsIdForFirstTime: '',
    filteredQuestionArray: [],
    type: '',
    onFeedbackClose: false,
    isClickedOnImport: false,
    removeUnresolvedFeedbackCount: {},
    removeUnresolvedFeedbackCountForTest: 0,
    onSavingQuestionTestData: {} 
};

const contentRequestAccordianSlice = createSlice({
    name: "contentRequestAccordian",
    initialState,
    reducers: {
        setAccordianState: (state = {}, action = {}) => {
            const { payload = {} } = action;
            return { ...state, accordianState: [...payload] }
        },
        setAccordingTouchIndex: (state = {}, action = {}) => {
            const { payload = {} } = action;
            return { ...state, accordianTouched: [...payload] }
        },
        setAccordianTouchWhileCreate: (state = {}, action = {}) => {
            const { accordianCreateTouched = {} } = state;
            const { payload = {} } = action;
            return { ...state, accordianCreateTouched: { ...accordianCreateTouched, ...payload } }
        },
        setIsComingFrom: (state = {}, action = {}) => {
            const { payload: { booleanValue = false } = {} } = action;
            return { ...state, isComingFromQuestionComponent: booleanValue }
        },
        setIsComingFromTest: (state = {}, action = {}) => {
            const { payload: { booleanValue = false } = {} } = action;
            return { ...state, isComingFromTest: booleanValue }
        },
        setIsTabOpened: (state = {}, action = {}) => {
            const { payload: { booleanValue = false } = {} } = action;
            return { ...state, isTabOpened: booleanValue }
        },
        setProgressBarForQuestion: (state = {}, action = {}) => {
            const { payload = {} } = action;
            const { progressBarForQuestion = {} } = state;
            return { ...state, progressBarForQuestion: { ...progressBarForQuestion, ...payload } }
        },
        setProgressBarForTest: (state = {}, action = {}) => {
            const { payload = {} } = action;
            const { progressBarForTest = {} } = state;
            return { ...state, progressBarForTest: { ...progressBarForTest, ...payload } }
        },
        setTestAccordian: (state = {}, action = {}) => {
            const { payload = {} } = action;
            return { ...state, accordianTest: [...payload] }
        },
        setIsBothTabOpen: (state = {}, action = {}) => {
            const { payload: { booleanValue = false } = {} } = action;
            return { ...state, isBothTabOpen: booleanValue }
        },
        setContentRequestItemsIdForFirstTime: (state = {}, action = {}) => {
            const { payload: { id = '' } = {} } = action;
            return { ...state, contentRequestItemsIdForFirstTime: id };
        },
        setFilterQuestionArray: (state = {}, action = {}) => {
            const { payload = {} } = action;
            return { ...state, filteredQuestionArray: [...payload] }
        },
        setType: (state = {}, action = {}) => {
            const { payload: { type = '' } } = action;
            return { ...state, type };
        },
        setOverallStatus: (state = {}, action = {}) => {
            const { payload: { booleanValue = false } = {} } = action;
            return { ...state, overAllStatus: booleanValue }
        },
        setFeedbackClose: (state = {}, action = {}) => {
            const { payload: { booleanValue = false } = {} } = action;
            return { ...state, onFeedbackClose: booleanValue }
        },
        setIsClickedOnImport: (state = {}, action = {}) => {
            const { payload: { booleanValue = false } = {} } = action;
            return { ...state, isClickedOnImport: booleanValue }
        },
        setRemoveUnresolvedFeedbackCount: (state = {}, action = {}) => {
            const { payload: { removeUnresolvedFeedbackCount = {} } = {} } = action;
            return { ...state, removeUnresolvedFeedbackCount }
        },
        setRemoveUnresolvedFeedbackCountForTest: (state = {}, action = {}) => {
            const { payload: { removeUnresolvedFeedbackCountForTest = 0 } = {} } = action;
            return { ...state, removeUnresolvedFeedbackCountForTest }
        }
    },
});

const { actions, reducer } = contentRequestAccordianSlice;
export default reducer;
export const contentRequestAccordianActions = actions;